/*!
 * egt.preview.dtspan — readable preview for egt.select.datetimespan values.
 * { windows:["morning"], days:"any", date:"2026-10-12", startTime:"14:00", endTime:"16:00" }
 *   -> "Morning · Any day" / "Monday, October 12, 2026, 2:00 PM – 4:00 PM"
 */
var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.preview.dtspan",
  title: "Control Preview: Date/Time Span",
  description: "Read-only preview for egt.select.datetimespan values.",
  fields: {
    value: { title: "Value", type: "*", description: "datetimespan object (or JSON string)." }
  }
});

var helper = require("../../uat/src/elements/helpers/control.preview.js");

var WINDOWS = { morning: "Morning", afternoon: "Afternoon", evening: "Evening" };
var DAYS = { weekdays: "Weekdays", weekends: "Weekends", any: "Any day" };

function parse(value) {
  if (typeof value === "string") {
    try { return JSON.parse(value); } catch (error) { return {}; }
  }
  return (value && typeof value === "object") ? value : {};
}

function time12(hhmm) {
  var m = /^(\d{1,2}):(\d{2})/.exec((hhmm || "").toString());
  if (!m) return (hhmm || "").toString();
  var h = Number(m[1]);
  return ((h % 12) || 12) + ":" + m[2] + " " + (h < 12 ? "AM" : "PM");
}

function day(iso) {
  var m = /^(\d{4})-(\d{2})-(\d{2})/.exec((iso || "").toString());
  if (!m) return (iso || "").toString();
  var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return d.toLocaleDateString("en-US", { weekday: "long", year: "numeric", month: "long", day: "numeric" });
}

function toLines(options) {
  var v = parse(options.value);
  var lines = [];

  var when = (v.windows instanceof Array ? v.windows : []).map(function (w) { return WINDOWS[w] || w; });
  if (v.days) when.push(DAYS[v.days] || v.days);
  if (when.length) lines.push(when.join(" · "));

  var span = [];
  if (v.date) span.push(day(v.date));
  if (v.startTime && v.endTime) span.push(time12(v.startTime) + " – " + time12(v.endTime));
  else if (v.startTime) span.push("from " + time12(v.startTime));
  else if (v.endTime) span.push("until " + time12(v.endTime));
  if (span.length) lines.push(span.join(", "));

  return lines;
}

exports.render = async function (options) {
  return helper.renderDoc(helper.jsonLines(toLines(options), "ua-control-preview-lines"));
};

/* Plain-text twin of render() for non-DOM surfaces (emails, logs, exports):
 * the same readable value, as a string. "" means nothing to show. */
exports.toText = function (options) {
  // ", " not " \u00b7 ": outgoing mail is folded to ASCII, which turns "\u00b7" into "*".
  return toLines(options || {}).filter(Boolean).join("\n").replace(/ \u00b7 /g, ", ");
};
